module.exports = __webpack_public_path__ + "static/media/inventory.0c90a7a6.png";